import { AxiosResponse } from "axios";
import { ASSETS, assetType, attachments, ClassCodeMaster, CodeTypeMaster, FaultAssetMappingMaster, IndentData, IndentFormData, InspectionAssetMappingMaster, InspectionReportPayload, ServiceReportPayload } from "../../types/assetTypes";
import Api from "../api";
import { CODETYPE_MASTER, CREATE_ASSET, CREATE_FAULT, CREATE_INDENT, CREATE_INDENTTEMPLATE, CREATE_INSPECTIONTEMPLATE, CREATE_SERVICETEMPLATE, DELETE_BY_ID_ASSET, DELETE_BY_ID_FAULT, DELETE_BY_ID_INSPECTION, DELETE_BY_ID_SERVICE, FAMILY_MASTER, GET_ASSET, GET_BY_FAMILY_ASSET, GET_BY_FAMILY_ASSETNAME, GET_BY_FAMILYID_ASSET, GET_BY_FAMILYID_EXTASSET, GET_BY_FAMILYID_EXTLOCAL_ASSET, GET_BY_FAMILYID_INTASSET, GET_BY_FAMILYID_INTLOCAL_ASSET, GET_BY_FAMILYID_TOOLASSET, GET_BY_FAMILYID_TOOLSLOCAL_ASSET, GET_BY_ID_ASSET, GET_BY_ID_FAULT, GET_EXTERNAL, GET_INDENT, GET_INDENTS, GET_INSPECTION, GET_INSPECTIONASSETMAP, GET_INSPECTIONTEMPLATE, GET_INTERNAL, GET_LIST_ASSET, GET_LIST_FAULT, GET_LIST_FAULT_BY_ID, GET_LOGISTICS, GET_PREV_FAULT_BY_ID, GET_SERVICE, GET_SERVICEASSETMAP, GET_SERVICETEMPLATE, GET_STOCK, GET_STOCKC, GET_STOCKT, GET_TIMESHEET, GET_TOOLS, INSPECTION_TEMPLATE, INSPECTIONASSETMAP_TEMPLATE, LOGISTICS_MASTER, SERVICEASSETMAP_TEMPLATE, TIMESHEET_MASTER, UPDATE_BY_ASSET, UPLOAD_FILE } from "../endpoint";
import { PaginationResponse, StatusResponse } from "../../types/type";
import { faultTypes, timesheetTypes } from "../../types/faultTypes";

type FilterValue = {
 
    value: string[];
  };
  
  type Filters = {
    [key: string]: FilterValue;
  };


export const createAssetData = async (payload:assetType) => {
    try{
        const response = await Api.post(CREATE_ASSET,payload);
        if(response.status === 201){
            return response;
        }else{
            throw new Error(`Create Asset Request failed with status code:${response.status}`);
        }
    }catch(err){
        throw err;
    }
}

export const uploadFiles = async (payload:FormData):Promise<{
    status: StatusResponse,
    data: attachments
}>  => {
    const config = {
        method: 'post',
        url: UPLOAD_FILE,
        data: payload,
        headers: {
            'Content-Type': 'multipart/form-data' // Explicitly set headers
        }
    }
    try{
        const response: AxiosResponse<{
            status: StatusResponse, 
            data: attachments
        }> = await Api(config);

        if(response.status === 200 || response.status === 201){
            return response.data;
        }else{
            throw new Error(`Request failed with status code:${response.status}`);
        }
    }catch(error){
        throw error;
    }
}

export const updateAssetData = async (payload:assetType) => {
    try{
        const response = await Api.put(UPDATE_BY_ASSET,payload);
        if(response.status === 200){
            return response;
        }else{
            throw new Error(`Update Asset Request failed with status code:${response.status}`);
        }
    }catch(err){
        throw err;
    }
}


export const getListOfAssets = async (page:number, rows: number, filter: Filters | undefined,searchTerm: string = ""): Promise<{
        status: StatusResponse, 
        data: [],
        pagination: PaginationResponse
    }> => {
    try{
        const payload = {
            limit:rows,
            offset: (page-1)*rows,
            page: page,
            filters: filter, 
            searchTerm: searchTerm,
        }
        const response: AxiosResponse<{
            status: StatusResponse, 
            data: [],
            pagination: PaginationResponse
        }> = await Api.post(`${GET_LIST_ASSET}/filter`,payload);
        if(response.status === 200){
            return response.data;
        }else{
            throw new Error(`Error in Get list of Asset with status code:${response.status}`);
        }
    }catch(err){
        throw err;
    }
}

export const getAssetByIdData = async (assetId:number): Promise<{
        status: StatusResponse, 
        data: assetType
    }> => {
    try{
        const response: AxiosResponse<{
            status: StatusResponse, 
            data: assetType,
        }> = await Api.get(`${GET_BY_ID_ASSET}/${assetId}`);
        if(response.status === 200){
            return response.data;
        }else{
            throw new Error(`Error in Get data by id of Asset with status code:${response.status}`);
        }
    }catch(err){
        throw err;
    }
}

export const getInspectionTemplateByIdData = async (inspectionTemplateId:number): Promise<{
        status: StatusResponse, 
        data: any
    }> => {
    try{
        const response: AxiosResponse<{
            status: StatusResponse, 
            data: any,
        }> = await Api.get(`${INSPECTION_TEMPLATE}/${inspectionTemplateId}`);
        if(response.status === 200){
            return response.data;
        }else{
            throw new Error(`Error in Get data by id of Asset with status code:${response.status}`);
        }
    }catch(err){
        throw err;
    }
}

export const handleAssetFilter = async (): Promise<{
    status: StatusResponse;
    data: { [key: string]: { id: number, name: string }[] }; // Adjust the data type to match the response structure
}> => {
    try {
        console.log("Fetching asset filter data...");

        const response: AxiosResponse<{
            status: StatusResponse;
            data: { [key: string]: { id: number, name: string }[] }; // Adjusted to match your response structure
        }> = await Api.get(GET_ASSET); // Simple GET request with no payload

        console.log("API Response:", response); // Log the full response

        if (response.status === 200) {
            console.log("Response data:", response.data); // Log the data from the response
            return response.data; // Return the data from the response
        } else {
            throw new Error(`Error fetching assets. Status code: ${response.status}`);
        }
    } catch (err) {
        console.error("Error in handleAssetFilter:", err);
        throw err;
    }
};

export const handleStock = async (): Promise<{
    status: StatusResponse;
    data: { [key: string]: { id: number, name: string }[] }; // Adjust the data type to match the response structure
}> => {
    try {
        console.log("Fetching asset filter data...");

        const response: AxiosResponse<{
            status: StatusResponse;
            data: { [key: string]: { id: number, name: string }[] }; // Adjusted to match your response structure
        }> = await Api.get(GET_STOCKC); // Simple GET request with no payload

        console.log("API Response:", response); // Log the full response

        if (response.status === 200) {
            console.log("Response data:", response.data); // Log the data from the response
            return response.data; // Return the data from the response
        } else {
            throw new Error(`Error fetching assets. Status code: ${response.status}`);
        }
    } catch (err) {
        console.error("Error in handleAssetFilter:", err);
        throw err;
    }
};

export const handleStockTransfer = async (): Promise<{
    status: StatusResponse;
    data: { [key: string]: { id: number, name: string }[] }; // Adjust the data type to match the response structure
}> => {
    try {
        console.log("Fetching asset filter data...");

        const response: AxiosResponse<{
            status: StatusResponse;
            data: { [key: string]: { id: number, name: string }[] }; // Adjusted to match your response structure
        }> = await Api.get(GET_STOCKT); // Simple GET request with no payload

        console.log("API Response:", response); // Log the full response

        if (response.status === 200) {
            console.log("Response data:", response.data); // Log the data from the response
            return response.data; // Return the data from the response
        } else {
            throw new Error(`Error fetching assets. Status code: ${response.status}`);
        }
    } catch (err) {
        console.error("Error in handleAssetFilter:", err);
        throw err;
    }
};




export const handleInternalAsset = async (): Promise<{
    status: StatusResponse;
    data: ASSETS[];
}> => {
    try {
        console.log("Fetching asset filter data...");

        const response: AxiosResponse<{
            status: StatusResponse;
            data: ASSETS[];
        }> = await Api.get(GET_INTERNAL); // Simple GET request with no payload

        console.log("API Response:", response); // Log the full response

        if (response.status === 200) {
            console.log("Response data:", response.data); // Log the data from the response
            return response.data; // Return the data from the response
        } else {
            throw new Error(`Error fetching assets. Status code: ${response.status}`);
        }
    } catch (err) {
        console.error("Error in handleAssetFilter:", err);
        throw err;
    }
};


export const handleToolAsset = async (): Promise<{
    status: StatusResponse;
    data: ASSETS[];
}> => {
    try {
        console.log("Fetching asset filter data...");

        const response: AxiosResponse<{
            status: StatusResponse;
            data: ASSETS[];
        }> = await Api.get(GET_TOOLS); // Simple GET request with no payload

        console.log("API Response:", response); // Log the full response

        if (response.status === 200) {
            console.log("Response data:", response.data); // Log the data from the response
            return response.data; // Return the data from the response
        } else {
            throw new Error(`Error fetching assets. Status code: ${response.status}`);
        }
    } catch (err) {
        console.error("Error in handleAssetFilter:", err);
        throw err;
    }
};


export const handleExternalAsset = async (): Promise<{
    status: StatusResponse;
    data: ASSETS[];
}> => {
    try {
        console.log("Fetching asset filter data...");

        const response: AxiosResponse<{
            status: StatusResponse;
            data: ASSETS[];
        }> = await Api.get(GET_EXTERNAL); // Simple GET request with no payload

        console.log("API Response:", response); // Log the full response

        if (response.status === 200) {
            console.log("Response data:", response.data); // Log the data from the response
            return response.data; // Return the data from the response
        } else {
            throw new Error(`Error fetching assets. Status code: ${response.status}`);
        }
    } catch (err) {
        console.error("Error in handleAssetFilter:", err);
        throw err;
    }
};




export const handleLogisticsFilter = async (): Promise<{
    status: StatusResponse;
    data: { [key: string]: { id: number, name: string }[] }; // Adjust the data type to match the response structure
}> => {
    try {
        console.log("Fetching asset filter data...");

        const response: AxiosResponse<{
            status: StatusResponse;
            data: { [key: string]: { id: number, name: string }[] }; // Adjusted to match your response structure
        }> = await Api.get(GET_LOGISTICS); // Simple GET request with no payload

        console.log("API Response:", response); // Log the full response

        if (response.status === 200) {
            console.log("Response data:", response.data); // Log the data from the response
            return response.data; // Return the data from the response
        } else {
            throw new Error(`Error fetching assets. Status code: ${response.status}`);
        }
    } catch (err) {
        console.error("Error in handleAssetFilter:", err);
        throw err;
    }
};

export const handleTimesheetFilter = async (): Promise<{
    status: StatusResponse;
    data: { [key: string]: { id: number, name: string }[] }; // Adjust the data type to match the response structure
}> => {
    try {
        console.log("Fetching asset filter data...");

        const response: AxiosResponse<{
            status: StatusResponse;
            data: { [key: string]: { id: number, name: string }[] }; // Adjusted to match your response structure
        }> = await Api.get(GET_TIMESHEET); // Simple GET request with no payload

        console.log("API Response:", response); // Log the full response

        if (response.status === 200) {
            console.log("Response data:", response.data); // Log the data from the response
            return response.data; // Return the data from the response
        } else {
            throw new Error(`Error fetching assets. Status code: ${response.status}`);
        }
    } catch (err) {
        console.error("Error in handleAssetFilter:", err);
        throw err;
    }
};


export const handleStockFilter = async (): Promise<{
    status: StatusResponse;
    data: { [key: string]: { id: number, name: string }[] }; // Adjust the data type to match the response structure
}> => {
    try {
        console.log("Fetching asset filter data...");

        const response: AxiosResponse<{
            status: StatusResponse;
            data: { [key: string]: { id: number, name: string }[] }; // Adjusted to match your response structure
        }> = await Api.get(GET_STOCK); // Simple GET request with no payload

        console.log("API Response:", response); // Log the full response

        if (response.status === 200) {
            console.log("Response data:", response.data); // Log the data from the response
            return response.data; // Return the data from the response
        } else {
            throw new Error(`Error fetching assets. Status code: ${response.status}`);
        }
    } catch (err) {
        console.error("Error in handleAssetFilter:", err);
        throw err;
    }
};


// export const handleAssetFilter = async (): Promise<{
//     status: StatusResponse;
//     data: [] // Change based on whether it's a single object or array
// }> => {
//     try {
//         const response: AxiosResponse<{
//             status: StatusResponse;
//             data: [] // Adjust this based on the response type (single object or array)
//         }> = await Api.get(GET_ASSET); // Simple GET request with no payload

//         if (response.status === 200) {
//             return response.data; // Return the data from the response
//         } else {
//             throw new Error(`Error fetching assets. Status code: ${response.status}`);
//         }
//     } catch (err) {
//         throw err;
//     }
// };


export const getUniqueAssetNamesByFamilyId = async (familyAssetId:number) => {
    try {
      const response = await Api.get(`${GET_BY_FAMILYID_ASSET}/${familyAssetId}`);
      return response.data; // Assuming the API returns an array of strings
    } catch (error) {
      console.error('Error fetching asset names:', error);
      return [];
    }
  }

  export const getUniqueIntAssetNamesByFamilyId = async (familyAssetId:number) => {
    try {
      const response = await Api.get(`${GET_BY_FAMILYID_INTASSET}/${familyAssetId}`);
      return response.data; // Assuming the API returns an array of strings
    } catch (error) {
      console.error('Error fetching asset names:', error);
      return [];
    }
  }

  export const getUniqueExtAssetNamesByFamilyId = async (familyAssetId:number) => {
    try {
      const response = await Api.get(`${GET_BY_FAMILYID_EXTASSET}/${familyAssetId}`);
      return response.data; // Assuming the API returns an array of strings
    } catch (error) {
      console.error('Error fetching asset names:', error);
      return [];
    }
  }

  export const getUniqueToolsAssetNamesByFamilyId = async (familyAssetId:number) => {
    try {
      const response = await Api.get(`${GET_BY_FAMILYID_TOOLASSET}/${familyAssetId}`);
      return response.data; // Assuming the API returns an array of strings
    } catch (error) {
      console.error('Error fetching asset names:', error);
      return [];
    }
  }

  const normalizeAssetLocalCodes = (items: any[] = []) =>
    items.map((item) => ({
      assetName: item.assetName ?? item.asset_name ?? "",
      localCode: item.localCode ?? item.local_code ?? "",
    }));

  export const getIntAssetLocalCodesByFamilyId = async (familyAssetId:number) => {
    try {
      const response = await Api.get(`${GET_BY_FAMILYID_INTLOCAL_ASSET}/${familyAssetId}`);
      const rawData = Array.isArray(response.data) ? response.data : response.data?.data ?? [];
      return {
        ...response.data,
        status: response.data?.status ?? { code: response.status, message: "Success" },
        data: normalizeAssetLocalCodes(rawData),
      };
    } catch (error) {
      console.error('Error fetching asset local codes:', error);
      return { status: { code: 500, message: "Failed to fetch asset local codes" }, data: [] };
    }
  }

  export const getExtAssetLocalCodesByFamilyId = async (familyAssetId:number) => {
    try {
      const response = await Api.get(`${GET_BY_FAMILYID_EXTLOCAL_ASSET}/${familyAssetId}`);
      const rawData = Array.isArray(response.data) ? response.data : response.data?.data ?? [];
      return {
        ...response.data,
        status: response.data?.status ?? { code: response.status, message: "Success" },
        data: normalizeAssetLocalCodes(rawData),
      };
    } catch (error) {
      console.error('Error fetching asset local codes:', error);
      return { status: { code: 500, message: "Failed to fetch asset local codes" }, data: [] };
    }
  }

  export const getToolsAssetLocalCodesByFamilyId = async (familyAssetId:number) => {
    try {
      const response = await Api.get(`${GET_BY_FAMILYID_TOOLSLOCAL_ASSET}/${familyAssetId}`);
      const rawData = Array.isArray(response.data) ? response.data : response.data?.data ?? [];
      return {
        ...response.data,
        status: response.data?.status ?? { code: response.status, message: "Success" },
        data: normalizeAssetLocalCodes(rawData),
      };
    } catch (error) {
      console.error('Error fetching tools asset local codes:', error);
      return { status: { code: 500, message: "Failed to fetch tools asset local codes" }, data: [] };
    }
  }

    export const getUniqueIntAssetName = async (familyAssetId:number) => {
    try {
      const response = await Api.get(`${GET_BY_FAMILYID_INTASSET}/group/${familyAssetId}`);
      return response.data; // Assuming the API returns an array of strings
    } catch (error) {
      console.error('Error fetching asset names:', error);
      return [];
    }
  }

  export const getUniqueExtAssetName= async (familyAssetId:number) => {
    try {
      const response = await Api.get(`${GET_BY_FAMILYID_EXTASSET}/group/${familyAssetId}`);
      return response.data; // Assuming the API returns an array of strings
    } catch (error) {
      console.error('Error fetching asset names:', error);
      return [];
    }
  }






export const getAssetNamesFamilyId = async (familyAssetId:number) => {
    try {
      const response = await Api.get(`${GET_BY_FAMILY_ASSETNAME}/${familyAssetId}`);
      return response.data; // Assuming the API returns an array of strings
    } catch (error) {
      console.error('Error fetching asset names:', error);
      return [];
    }
  }


export const getAssetNamesByFamilyId = async (familyAssetId:number) => {
    try {
      const response = await Api.get(`${GET_BY_FAMILY_ASSET}/${familyAssetId}`);
      return response.data; // Assuming the API returns an array of strings
    } catch (error) {
      console.error('Error fetching asset names:', error);
      return [];
    }
  }


export const deleteAssetDetails = async (assetId:number) => {
    try{
        const response = await Api.delete(`${DELETE_BY_ID_ASSET}/${assetId}`);
        if(response.status === 200){
            return response;
        }else{
            throw new Error(`Error in delete data by id of Asset with status code:${response.status}`);
        }
    }catch(err){
        throw err;
    }
}

export const deleteLogistics= async (logisticsId:number) => {
    try{
        const response = await Api.delete(`${LOGISTICS_MASTER}/${logisticsId}`);
        if(response.status === 200){
            return response;
        }else{
            throw new Error(`Error in delete data by id of Asset with status code:${response.status}`);
        }
    }catch(err){
        throw err;
    }
}

//fault 

export const createFaultData = async (payload:faultTypes) => {
    try{
        const response:AxiosResponse<{status:StatusResponse,data:any}> = await Api.post(CREATE_FAULT,payload);
        if(response.status === 201){
            return response.data;
        }else{
            throw new Error(`Create Asset Request failed with status code:${response.status}`);
        }
    }catch(err){
        throw err;
    }
}

export const getAssetMappingData = async (payload:FaultAssetMappingMaster) => {
    try{
        const response:AxiosResponse<{status:StatusResponse,data:any}> = await Api.post(SERVICEASSETMAP_TEMPLATE,payload);
        if(response.status === 200){
            return response.data;
        }else{
            throw new Error(`Get service Asset Request failed with status code:${response.status}`);
        }
    }catch(err){
        throw err;
    }
}

export const getInspectionAssetMappingData = async (payload:InspectionAssetMappingMaster) => {
    try{
        const response:AxiosResponse<{status:StatusResponse,data:any}> = await Api.post(INSPECTIONASSETMAP_TEMPLATE,payload);
        if(response.status === 200){
            return response.data;
        }else{
            throw new Error(`Get service Asset Request failed with status code:${response.status}`);
        }
    }catch(err){
        throw err;
    }
}

export const updateFaultData = async (payload:faultTypes) => {
    try{
        const response:AxiosResponse<{status:StatusResponse,data:any}> = await Api.put(CREATE_FAULT,payload);
        if(response.status === 200){
            return response.data;
        }else{
            throw new Error(`Create Asset Request failed with status code:${response.status}`);
        }
    }catch(err){
        throw err;
    }
}

export const getListOfFault = async (page:number, rows: number, filter: Record<string, any>,searchTerm: string = ""): Promise<{
        status: StatusResponse, 
        data: [],
        pagination: PaginationResponse
    }> => {
    try{
        const payload = {
            limit:rows,
            offset: page,
            
            page: page,
            filters: filter, 
            searchTerm: searchTerm,
        }
        const response: AxiosResponse<{
            status: StatusResponse, 
            data: [],
            pagination: PaginationResponse
        }> = await Api.post(`${GET_LIST_FAULT}/filter`,payload);
        if(response.status === 200){
            return response.data;
        }else{
            throw new Error(`Error in Get list of Asset with status code:${response.status}`);
        }
    }catch(err){
        throw err;
    }
}

export const getFaultByIdData = async (faultId:number): Promise<{
        status: StatusResponse, 
        data: faultTypes
    }> => {
    try{
        const response: AxiosResponse<{
            status: StatusResponse, 
            data: faultTypes
        }> = await Api.get(`${GET_BY_ID_FAULT}/${faultId}`);
        if(response.status === 200){
            return response.data;
        }else{
            throw new Error(`Error in Get data by id of Fault with status code:${response.status}`);
        }
    }catch(err){
        throw err;
    }
}

export const getPrevFaultByUserIdData = async (user_id:number): Promise<{
    status: StatusResponse, 
    data: faultTypes
}> => {
try{
    const response: AxiosResponse<{
        status: StatusResponse, 
        data: faultTypes,
    }> = await Api.get(`${GET_PREV_FAULT_BY_ID}/${user_id}`);
    if(response.status === 200){
        return response.data;
    }else{
        throw new Error(`Error in Get data by id of Fault with status code:${response.status}`);
    }
}catch(err){
    throw err;
}
}

export const getFaultByUserIdData = async (user_id:number): Promise<{
    status: StatusResponse, 
    data: assetType
}> => {
try{
    const response: AxiosResponse<{
        status: StatusResponse, 
        data: assetType,
    }> = await Api.get(`${GET_LIST_FAULT_BY_ID}/${user_id}`);
    if(response.status === 200){
        return response.data;
    }else{
        throw new Error(`Error in Get data by id of Fault with status code:${response.status}`);
    }
}catch(err){
    throw err;
}
}


export const deleteFaultDetails = async (faultId:number) => {
    try{
        const response = await Api.delete(`${DELETE_BY_ID_FAULT}/${faultId}`);
        if(response.status === 200){
            return response;
        }else{
            throw new Error(`Error in delete data by id of Fault with status code:${response.status}`);
        }
    }catch(err){
        throw err;
    }
}

export const saveServiceData = async (payload:ServiceReportPayload) => {
    try{
        const response:AxiosResponse<{status:StatusResponse,data:any}> = await Api.post(CREATE_SERVICETEMPLATE,payload);
        if(response.status === 201){
            return response.data;
        }else{
            throw new Error(`Create Asset Request failed with status code:${response.status}`);
        }
    }catch(err){
        throw err;
    }
}


export const saveInspectionData = async (payload:InspectionReportPayload) => {
    try{
        const response:AxiosResponse<{status:StatusResponse,data:any}> = await Api.post(CREATE_INSPECTIONTEMPLATE,payload);
        if(response.status === 201|| response.status === 201) {
            return response.data;
        }else{
            throw new Error(`Create Asset Request failed with status code:${response.status}`);
        }
    }catch(err){
        throw err;
    }
}

export const updateInspectionData = async (payload: InspectionReportPayload) => {
    try {
        const response: AxiosResponse<{status: StatusResponse, data: any}> = await Api.put(CREATE_INSPECTIONTEMPLATE, payload);
        
        if (response.status === 200 || response.status === 201) { // Accept both 200 and 201
            return response.data;
        } else {
            throw new Error(`Create Asset Request failed with status code: ${response.status}`);
        }
    } catch (err) {
        throw err;
    }
};


// export const saveInspectionData = async (payload:InspectionReportPayload):Promise<{ status: StatusResponse, data: any}> => {
//     const config = {
//         method: payload.inspectionReportingId === 0 ? 'post' : 'put',
//         url: CREATE_INSPECTIONTEMPLATE,
//         data: payload
//     }
//     try{
//         const response: AxiosResponse<{
//             status: StatusResponse, 
//             data: any
//         }> = await Api(config);

//         if(response.status === 200 || response.status === 201){
//             return response.data;
//         }else{
//             throw new Error(`Request failed with status code:${response.status}`);
//         }
//     }catch(error){
//         throw error;
//     }
// };


export const getInspectionColumnDetails= async (user_id:number): Promise<{
    status: StatusResponse, 
    data: assetType
}> => {
try{
    const response: AxiosResponse<{
        status: StatusResponse, 
        data: assetType,
    }> = await Api.get(`${GET_LIST_FAULT_BY_ID}/${user_id}`);
    if(response.status === 200){
        return response.data;
    }else{
        throw new Error(`Error in Get data by id of Fault with status code:${response.status}`);
    }
}catch(err){
    throw err;
}
}

export const updateServiceData = async (payload: ServiceReportPayload) => {
    try {
        const response: AxiosResponse<{status: StatusResponse, data: any}> = await Api.put(CREATE_SERVICETEMPLATE, payload);
        
        if (response.status === 200 || response.status === 201) { // Accept both 200 and 201
            return response.data;
        } else {
            throw new Error(`Create Asset Request failed with status code: ${response.status}`);
        }
    } catch (err) {
        throw err;
    }
};


export const handleServiceFilter = async (): Promise<{
    status: StatusResponse;
    data: { [key: string]: { id: number, name: string }[] }; // Adjust the data type to match the response structure
}> => {
    try {
        console.log("Fetching asset filter data...");

        const response: AxiosResponse<{
            status: StatusResponse;
            data: { [key: string]: { id: number, name: string }[] }; // Adjusted to match your response structure
        }> = await Api.get(GET_SERVICE); // Simple GET request with no payload

        console.log("API Response:", response); // Log the full response

        if (response.status === 200) {
            console.log("Response data:", response.data); // Log the data from the response
            return response.data; // Return the data from the response
        } else {
            throw new Error(`Error fetching assets. Status code: ${response.status}`);
        }
    } catch (err) {
        console.error("Error in handleAssetFilter:", err);
        throw err;
    }
};


export const handleServiceTemplateFilter = async (): Promise<{
    status: StatusResponse;
    data: { [key: string]: { id: number, name: string }[] }; // Adjust the data type to match the response structure
}> => {
    try {
        console.log("Fetching asset filter data...");

        const response: AxiosResponse<{
            status: StatusResponse;
            data: { [key: string]: { id: number, name: string }[] }; // Adjusted to match your response structure
        }> = await Api.get(GET_SERVICETEMPLATE); // Simple GET request with no payload

        console.log("API Response:", response); // Log the full response

        if (response.status === 200) {
            console.log("Response data:", response.data); // Log the data from the response
            return response.data; // Return the data from the response
        } else {
            throw new Error(`Error fetching assets. Status code: ${response.status}`);
        }
    } catch (err) {
        console.error("Error in handleAssetFilter:", err);
        throw err;
    }
};

export const handleIndentFilter = async (
    params: { userId: number; projectIds: number[] }
): Promise<{
    status: StatusResponse;
    data: { [key: string]: { id: number; name: string }[] };
}> => {
    try {
        console.log("Fetching indent filter data...");

        const response: AxiosResponse<{
            status: StatusResponse;
            data: { [key: string]: { id: number; name: string }[] };
        }> = await Api.get(GET_INDENTS, {
            params: {
                userId: params.userId,
                projectIds: params.projectIds.join(","),
            },
        });

        if (response.status === 200) {
            return response.data;
        } else {
            throw new Error(`Error fetching assets. Status code: ${response.status}`);
        }
    } catch (err) {
        console.error("Error in handleIndentFilter:", err);
        throw err;
    }
};



// export const handleIndentFilter = async (): Promise<{
//     status: StatusResponse;
//     data: { [key: string]: { id: number, name: string }[] }; // Adjust the data type to match the response structure
// }> => {
//     try {
//         console.log("Fetching asset filter data...");

//         const response: AxiosResponse<{
//             status: StatusResponse;
//             data: { [key: string]: { id: number, name: string }[] }; // Adjusted to match your response structure
//         }> = await Api.get(GET_INDENTS); // Simple GET request with no payload

//         console.log("API Response:", response); // Log the full response

//         if (response.status === 200) {
//             console.log("Response data:", response.data); // Log the data from the response
//             return response.data; // Return the data from the response
//         } else {
//             throw new Error(`Error fetching assets. Status code: ${response.status}`);
//         }
//     } catch (err) {
//         console.error("Error in handleAssetFilter:", err);
//         throw err;
//     }
// };




export const handleServiceAssetFilter = async (): Promise<{
    status: StatusResponse;
    data: { [key: string]: { id: number, name: string }[] }; // Adjust the data type to match the response structure
}> => {
    try {
        console.log("Fetching asset filter data...");

        const response: AxiosResponse<{
            status: StatusResponse;
            data: { [key: string]: { id: number, name: string }[] }; // Adjusted to match your response structure
        }> = await Api.get(GET_SERVICEASSETMAP); // Simple GET request with no payload

        console.log("API Response:", response); // Log the full response

        if (response.status === 200) {
            console.log("Response data:", response.data); // Log the data from the response
            return response.data; // Return the data from the response
        } else {
            throw new Error(`Error fetching assets. Status code: ${response.status}`);
        }
    } catch (err) {
        console.error("Error in handleAssetFilter:", err);
        throw err;
    }
};

export const handleInspectionFilter = async (): Promise<{
    status: StatusResponse;
    data: { [key: string]: { id: number, name: string }[] }; // Adjust the data type to match the response structure
}> => {
    try {
        console.log("Fetching asset filter data...");

        const response: AxiosResponse<{
            status: StatusResponse;
            data: { [key: string]: { id: number, name: string }[] }; // Adjusted to match your response structure
        }> = await Api.get(GET_INSPECTION); // Simple GET request with no payload

        console.log("API Response:", response); // Log the full response

        if (response.status === 200) {
            console.log("Response data:", response.data); // Log the data from the response
            return response.data; // Return the data from the response
        } else {
            throw new Error(`Error fetching assets. Status code: ${response.status}`);
        }
    } catch (err) {
        console.error("Error in handleAssetFilter:", err);
        throw err;
    }
};


export const handleInspectionTemplateFilter = async (): Promise<{
    status: StatusResponse;
    data: { [key: string]: { id: number, name: string }[] }; // Adjust the data type to match the response structure
}> => {
    try {
        console.log("Fetching asset filter data...");

        const response: AxiosResponse<{
            status: StatusResponse;
            data: { [key: string]: { id: number, name: string }[] }; // Adjusted to match your response structure
        }> = await Api.get(GET_INSPECTIONTEMPLATE); // Simple GET request with no payload

        console.log("API Response:", response); // Log the full response

        if (response.status === 200) {
            console.log("Response data:", response.data); // Log the data from the response
            return response.data; // Return the data from the response
        } else {
            throw new Error(`Error fetching assets. Status code: ${response.status}`);
        }
    } catch (err) {
        console.error("Error in handleAssetFilter:", err);
        throw err;
    }
};


export const handleInspetionMapFilter = async (): Promise<{
    status: StatusResponse;
    data: { [key: string]: { id: number, name: string }[] }; // Adjust the data type to match the response structure
}> => {
    try {
        console.log("Fetching asset filter data...");

        const response: AxiosResponse<{
            status: StatusResponse;
            data: { [key: string]: { id: number, name: string }[] }; // Adjusted to match your response structure
        }> = await Api.get(GET_INSPECTIONASSETMAP); // Simple GET request with no payload

        console.log("API Response:", response); // Log the full response

        if (response.status === 200) {
            console.log("Response data:", response.data); // Log the data from the response
            return response.data; // Return the data from the response
        } else {
            throw new Error(`Error fetching assets. Status code: ${response.status}`);
        }
    } catch (err) {
        console.error("Error in handleAssetFilter:", err);
        throw err;
    }
};



export const createIndent = async (payload:IndentFormData) => {
    try{
        const response = await Api.post(CREATE_INDENT,payload);
        if(response.status === 201){
            return response;
        }else{
            throw new Error(`Create Asset Request failed with status code:${response.status}`);
        }
    }catch(err){
        throw err;
    }
}

export const createIndentTemplate = async (payload:IndentFormData) => {
    try{
        const response = await Api.post(CREATE_INDENTTEMPLATE,payload);
        if(response.status === 201){
            return response;
        }else{
            throw new Error(`Create Asset Request failed with status code:${response.status}`);
        }
    }catch(err){
        throw err;
    }
}

export const updateIndentTemplate = async (payload:IndentFormData) => {
    try{
        const response = await Api.put(CREATE_INDENTTEMPLATE,payload);
        if(response.status === 201){
            return response;
        }else{
            throw new Error(`Indent update  Request failed with status code:${response.status}`);
        }
    }catch(err){
        throw err;
    }
}


export const updateIndent = async (payload:IndentFormData) => {
    try{
        const response = await Api.put(CREATE_INDENT,payload);
        if(response.status === 201){
            return response;
        }else{
            throw new Error(`Indent update  Request failed with status code:${response.status}`);
        }
    }catch(err){
        throw err;
    }
}

export const getIndentTemplateByIdData = async (indentTemplateId:number): Promise<{
    status: StatusResponse, 
    data: IndentFormData
}> => {
try{
    const response: AxiosResponse<{
        status: StatusResponse, 
        data: IndentFormData,
    }> = await Api.get(`${CREATE_INDENTTEMPLATE}/${indentTemplateId}`);
    if(response.status === 200){
        return response.data;
    }else{
        throw new Error(`Error in Get data by id of Asset with status code:${response.status}`);
    }
}catch(err){
    throw err;
}
}
export const getIndentsData = async (indentId:number): Promise<{
    status: StatusResponse, 
    data: IndentData[]
}> => {
try{
    const response: AxiosResponse<{
        status: StatusResponse, 
        data: IndentData[],
    }> = await Api.get(`${GET_INDENT}/${indentId}`);
    if(response.status === 200){
        return response.data;
    }else{
        throw new Error(`Error in Get data by id of Asset with status code:${response.status}`);
    }
}catch(err){
    throw err;
}
}


export const getIndentByIdData = async (indentId:number): Promise<{
    status: StatusResponse, 
    data: IndentFormData
}> => {
try{
    const response: AxiosResponse<{
        status: StatusResponse, 
        data: IndentFormData,
    }> = await Api.get(`${CREATE_INDENT}/${indentId}`);
    if(response.status === 200){
        return response.data;
    }else{
        throw new Error(`Error in Get data by id of Asset with status code:${response.status}`);
    }
}catch(err){
    throw err;
}
}

export const getClassCodeByFamilyAssetId = async (familyAssetId:number): Promise<{
        status: StatusResponse, 
        data: ClassCodeMaster[]
    }> => {
    try{
        const response: AxiosResponse<{
            status: StatusResponse, 
            data: ClassCodeMaster[]
        }> =  await Api.get(`${FAMILY_MASTER}/codeType/${familyAssetId}`);
        if(response.status === 200){
            return response.data;
        }else{
            throw new Error(`Error in Get data by id of Asset with status code:${response.status}`);
        }
    }catch(err){
        throw err;
    }
}

export const deleteService = async (serviceReportingId:number) => {
    try{
        const response = await Api.delete(`${DELETE_BY_ID_SERVICE}/${serviceReportingId}`);
        if(response.status === 200){
            return response;
        }else{
            throw new Error(`Error in delete data by id of Asset with status code:${response.status}`);
        }
    }catch(err){
        throw err;
    }
}

export const deleteInspection = async (inspectionReportingId:number) => {
    try{
        const response = await Api.delete(`${DELETE_BY_ID_INSPECTION}/${inspectionReportingId}`);
        if(response.status === 200){
            return response;
        }else{
            throw new Error(`Error in delete data by id of Asset with status code:${response.status}`);
        }
    }catch(err){
        throw err;
    }
}

export const getTimesheetByIdData = async (timeSheetId:number): Promise<{
        status: StatusResponse, 
        data: timesheetTypes
    }> => {
    try{
        const response: AxiosResponse<{
            status: StatusResponse, 
            data: timesheetTypes
        }> = await Api.get(`${TIMESHEET_MASTER}/${timeSheetId}`);
        if(response.status === 200){
            return response.data;
        }else{
            throw new Error(`Error in Get data by id of Asset with status code:${response.status}`);
        }
    }catch(err){
        throw err;
    }
}
